import React from 'react'
import { inject, observer } from 'mobx-react'
import { withTranslation } from 'react-i18next'
import PaneHeader from '../panes/PaneHeader'

const DeleteItemPrompt = ({
  item,
  itemName = '',
  itemType,
  title,
  description,
  onSubmit,
  dataStore,
  uiStore,
  t
}) => {
  let displayTitle = title
  let cleanName = itemName
  let displayDesc = description

  if (!displayTitle || !displayDesc) {
    let detectedType = itemType
    if (!detectedType) {
      if (/^target\s*group:\s*/i.test(cleanName)) {
        detectedType = 'targetGroup'
        cleanName = cleanName.replace(/^target\s*group:\s*/i, '')
      } else if (/^region:\s*/i.test(cleanName)) {
        detectedType = 'region'
        cleanName = cleanName.replace(/^region:\s*/i, '')
      } else if (/^boundary:\s*/i.test(cleanName)) {
        detectedType = 'boundary'
        cleanName = cleanName.replace(/^boundary:\s*/i, '')
      } else if (/^marker:\s*/i.test(cleanName)) {
        detectedType = 'marker'
        cleanName = cleanName.replace(/^marker:\s*/i, '')
      } else if (/^shapefile:\s*/i.test(cleanName)) {
        detectedType = 'shapefile'
        cleanName = cleanName.replace(/^shapefile:\s*/i, '')
      } else if (/^marker\s*file:\s*/i.test(cleanName)) {
        detectedType = 'markerfile'
        cleanName = cleanName.replace(/^marker\s*file:\s*/i, '')
      }
    }

    if (!displayTitle) {
      switch (detectedType) {
        case 'targetGroup':
          displayTitle = t('GLOBAL.DELETE_TARGET_GROUP_Q', { defaultValue: 'Delete target group?' })
          break
        case 'region':
          displayTitle = t('GLOBAL.DELETE_REGION_Q', { defaultValue: 'Delete region?' })
          break
        case 'boundary':
          displayTitle = t('GLOBAL.DELETE_BOUNDARY_Q', { defaultValue: 'Delete boundary?' })
          break
        case 'marker':
          displayTitle = t('GLOBAL.DELETE_MARKER_Q', { defaultValue: 'Delete marker?' })
          break
        case 'shapefile':
          displayTitle = t('GLOBAL.DELETE_SHAPEFILE_Q', { defaultValue: 'Delete shapefile?' })
          break
        case 'markerfile':
          displayTitle = t('GLOBAL.DELETE_MARKERFILE_Q', { defaultValue: 'Delete marker file?' })
          break
        default:
          displayTitle = t('GLOBAL.DELETE_ITEM_Q', { defaultValue: 'Delete item?' })
      }
    }

    if (!displayDesc) {
      switch (detectedType) {
        case 'targetGroup':
          displayDesc = t('GLOBAL.DELETE_TARGET_GROUP_DESC', {
            defaultValue: 'This target group and all saved items inside it will be permanently removed.'
          })
          break
        case 'region':
          displayDesc = t('GLOBAL.DELETE_REGION_DESC', {
            defaultValue: 'This region and all saved items inside it will be permanently removed.'
          })
          break
        case 'boundary':
          displayDesc = t('GLOBAL.DELETE_BOUNDARY_DESC', {
            defaultValue: 'This boundary and all saved items inside it will be permanently removed.'
          })
          break
        case 'marker':
          displayDesc = t('GLOBAL.DELETE_MARKER_DESC', {
            defaultValue: 'This marker and all saved items inside it will be permanently removed.'
          })
          break
        default:
          displayDesc = t('GLOBAL.DELETE_ITEM_DESC', {
            defaultValue: 'This item and all saved items inside it will be permanently removed.'
          })
      }
    }
  }

  return (
    <div
      id='delete-item-prompt'
      className='click-tooltip delete-prompt'
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
    >
      <PaneHeader
        title={displayTitle}
        onClose={(e) => {
          if (e && e.stopPropagation) e.stopPropagation()
          uiStore.hideDeletePrompt()
        }}
      />

      <div className='delete-prompt__body'>
        <div className='delete-prompt__item-name'>{cleanName}</div>
        <p className='delete-prompt__desc'>{displayDesc}</p>
        <p className='delete-prompt__warning'>
          {t('GLOBAL.ACTION_CANNOT_BE_UNDONE', { defaultValue: 'This action cannot be undone.' })}
        </p>
      </div>

      <div className='tooltip-actions'>
        <button
          type='button'
          className='btn-cancel'
          onClick={(e) => {
            e.stopPropagation()
            uiStore.hideDeletePrompt()
          }}
        >
          {t('GLOBAL.CANCEL', { defaultValue: 'Cancel' })}
        </button>
        <button
          type='button'
          className='btn-delete'
          onClick={() => {
            onSubmit()
            uiStore.hideDeletePrompt()
          }}
        >
          {t('GLOBAL.YES_DELETE', { defaultValue: 'Yes, delete' })}
        </button>
      </div>
    </div>
  )
}

export default withTranslation()(inject('dataStore', 'uiStore')(observer(DeleteItemPrompt)))
